/**
 * Date utility functions for Warehouse module
 */

/**
 * Format date string to human-readable format with time.
 */
export const formatDateTime = (dateStr?: string): string => {
    if (!dateStr) return 'N/A'
    return new Date(dateStr).toLocaleString('en-US', {
        month: 'short',
        day: 'numeric',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
    })
}

/**
 * Format date string to human-readable format without time.
 */
export const formatDate = (dateStr?: string): string => {
    if (!dateStr) return 'N/A'
    return new Date(dateStr).toLocaleString('en-US', {
        month: 'short',
        day: 'numeric',
        year: 'numeric',
    })
}
